import { render } from "./App.vue?vue&type=template&id=75ea4571"
const script = {}

import "./App.vue?vue&type=style&index=0&id=75ea4571&lang=css"
script.render = render

export default script